import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  users: [],
  userDetails: {},
  roles: [],
  roleDetails: {},
  permissionsData:[],

  permissions: []
};

// export const getAllUsers = createAsyncThunk(
//   "auth/getUsers",
//   async ({ pagination, limit, offset }, { rejectWithValue }) => {
//     try {
//       const response = await api.users.getUsers({ pagination, limit, offset });
//       if (response.status === 200) {
//         return response.data;
//       } else {
//         return rejectWithValue(`Unexpected status code: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("Failed to get users:", error);
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const createUser = createAsyncThunk(
  "users/createUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.users.createUser(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to create user:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async ({ id, payload, token }, { rejectWithValue }) => {
    // Include token in the parameters
    try {
      const response = await api.users.updateUser(id, payload, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the Authorization header
          "Content-Type": "application/json", // Optional: if you need this for the request
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to update user:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteUserThunk = createAsyncThunk(
  "users/deleteuser",
  async ({ id, token }, { rejectWithValue }) => {
    // Include token in the parameters
    try {
      const response = await api.users.deleteUser(id, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the Authorization header
          "Content-Type": "application/json", // Optional: if you need this for the request
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to update user:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCurrentUser = createAsyncThunk(
  "users/getCurrentUser",
  async ({ id, token }, { rejectWithValue }) => {
    // Include token in the parameters
    try {
      const response = await api.users.getCurrentUser(id, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the Authorization header
          "Content-Type": "application/json", // Optional: if you need this for the request
        },
      });
      if (response.status === 200) {
        console.log("response.data--------------",response.data)
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to update user:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// export const updateUser = createAsyncThunk(
//   "users/updateUser",
//   async ({ id, payload }, { rejectWithValue }) => {
//     try {
//       const response = await api.users.updateUser(id, payload);
//       if (response.status === 200) {
//         return response.data;
//       } else {
//         return rejectWithValue(`Unexpected status code: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("Failed to update user:", error);
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const getAllUsers = createAsyncThunk(
  "usersData/getAllUsers",
  async (payload) => {
    try {
      const response = await api.users.getUsers(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAllRoles = createAsyncThunk(
  "usersData/getAllRoles",
  async (payload) => {
    try {
      const response = await api.users.getRoles(payload);
      if (response.status === 200 || response.status===201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createRole = createAsyncThunk(
  "usersData/createRole",
  async (payload) => {
    try {
      const response = await api.users.createRole(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateRole = createAsyncThunk(
  "usersData/updateRole",
  async ({ id, payload }) => {
    try {
      const response = await api.users.updateRole(id, payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getPermissions = createAsyncThunk(
  "usersData/getPermissions",
  async (payload) => {
    try {
      const response = await api.users.getPermissions(payload);
      if (response.status === 200 || response.status===201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const getRoleAccessByEmail = createAsyncThunk(
  "auth/getRoleAccessByEmail",
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await api.users.getRoleAccessByEmail({ email });
      console.log(response, "response from getRoleAccessByEmail");
      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Login failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAllPrograms = createAsyncThunk(
  "programData/getAllPrograms",
  async (payload) => {
    try {
      const response = await api.users.getPrograms(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const createPermissions = createAsyncThunk(
  "usersData/createPermissions",
  async (payload) => {
    try {
      const response = await api.users.createPermissions(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAllServices = createAsyncThunk(
  "serviceData/getAllServices",
  async (payload) => {
    try {
      const response = await api.users.getServices(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const getAllSubServices = createAsyncThunk(
  "subServiceData/getAllSubServices",
  async (payload) => {
    try {
      const response = await api.users.getSubServices(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deletePermissions = createAsyncThunk(
  "usersData/deletePermissions",
  async (payload) => {
    try {
      const response = await api.users.deletePermissions(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);



const customerSlice = createSlice({
  name: "usersData",
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      console.log(action, "assign state");
      state.userDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        console.log("pending");
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        state.users = action.payload;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        state.roles = action.payload;
      })

      .addCase(getPermissions.pending, (state) => {
        console.log("pending");
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        state.permissionsData = action.payload;
      })
      .addCase(getPermissions.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      })

      .addCase(getRoleAccessByEmail.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload, "role access by email");
        // state.permissions = action.payload?.Roles?.RolePermissions || [];
        const newArr = [...new Set(action.payload?.role?.RolePermissions?.map(p => p.Permissions?.permission_value))
        ];
        state.permissions = newArr || [];

      })
  },
});

export const { setCustomer } = customerSlice.actions;

export default customerSlice.reducer;
